import {
	Action,
	type GenericAuthorizationMap,
	Model,
} from "src/contexts/authorization-context";
import { AccountFeatureFlags } from "src/types/portal-features.type";

type CustomAnalyticsAuthorization = {
	customAnalytics: GenericAuthorizationMap<
		"index" | "premiumAnalyticsLanding"
	>;
};

export const customAnalyticsAuthorization: CustomAnalyticsAuthorization = {
	customAnalytics: {
		index: {
			can: {
				allOf: [
					[Action.view, Model.CUSTOM_ANALYTICS],
					[
						Action.useAccountFeature,
						AccountFeatureFlags.hasCustomAnalytics,
					],
				],
			},
		},
		premiumAnalyticsLanding: {
			cannot: {
				allOf: [
					[
						Action.useAccountFeature,
						AccountFeatureFlags.hasCustomAnalytics,
					],
				],
			},
		},
	},
};
